import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { Card, CARD_PADDING_SIZE } from 'components/Card'
import Icon, { ICON_SIZE } from 'components/Icon/Icon'
import { Flex } from 'components/Layout'
import { H4, Text } from 'components/Typography'
import {
  COLOR,
  FONT_SIZE,
  SPACE,
  FONT_WEIGHT,
  LAYOUT_WRAPPER_MAX_WIDTH,
} from 'Theme'

const ExpertiseWrapper = styled(Flex)`
  &:last-child {
    margin-bottom: 0;
  }
`

export const ExpertExpertises = ({ expertData }) =>
  expertData.expertises?.length > 0 && (
    <Card
      flexShrink={0}
      flexDirection="column"
      paddingSize={CARD_PADDING_SIZE.LARGE}
    >
      <Flex
        mt={SPACE.PX_10}
        mb={SPACE.PX_40}
        width="100%"
        justifyContent="center"
      >
        <Flex
          maxWidth={LAYOUT_WRAPPER_MAX_WIDTH}
          justifyContent="center"
          flexWrap="wrap"
        >
          <H4 as="h2" m={0} textAlign="center">
            {expertData.profileName}
          </H4>
          <Text
            fontWeight={FONT_WEIGHT.MEDIUM}
            color={COLOR.GRAYSCALE_3}
            fontSize={FONT_SIZE.PX_20}
            lineHeight={1.3}
            ml={SPACE.PX_5}
          >
            can advise on
          </Text>
        </Flex>
      </Flex>
      <Flex flexWrap="wrap" justifyContent="space-between" mb={SPACE.PX_10}>
        {expertData.expertises.map(({ id, expertise }) => (
          <ExpertiseWrapper
            width={{ MOBILE: '100%', TABLET: `calc(50% - ${SPACE.PX_20})` }}
            key={id}
            mb={SPACE.PX_20}
          >
            <Flex mt="2px">
              <Icon.Checkmark size={ICON_SIZE.PX_16} />
            </Flex>
            <Flex ml={SPACE.PX_10}>{expertise}</Flex>
          </ExpertiseWrapper>
        ))}
      </Flex>
    </Card>
  )

ExpertExpertises.propTypes = {
  expertData: PropTypes.shape({
    profileName: PropTypes.string,
    expertises: PropTypes.arrayOf(PropTypes.shape({})),
  }),
}
